import type { ChatMessage } from "@care-by-ella/contracts";

/**
 * TES-719 — which media key to show beside a staff message in the admin
 * thread. The API resolves it per author (`senderAvatarMediaKey`: their own
 * portrait once uploaded, else the tenant's role slot; null = neither). An
 * unauthored message, or a response from an API before TES-719 (field
 * absent), gets the role slot, which is what every message showed before.
 */
export function senderPortraitKey(
  m: Pick<ChatMessage, "senderId" | "senderAvatarMediaKey">,
  roleSlotKey: string | undefined,
): string | undefined {
  if (!m.senderId || m.senderAvatarMediaKey === undefined) return roleSlotKey;
  return m.senderAvatarMediaKey ?? undefined;
}
